import { Config } from 'models/config';

class App {
  appUrl: string;

  constructor(appUrl: string) {
    this.appUrl = appUrl;
  }

  generateUrl(path: string) {
    return this.appUrl + path;
  }
}

let app = new App('');

export function configureApp(config: Config) {
  app = new App(config.appUrl);
}

export { app };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/app.ts